import termsLoaderHOC from "./TermsLoaderHOC";
import TermsModal from "./TermsModal";

const TermsModalWrapped = termsLoaderHOC(TermsModal);

export default TermsModalWrapped;
